import {Generics, verticalPage} from "./generics.ts";
import {create} from "../../fjsc/src/f2.ts";
import {BagelInfo} from "../models/BagelInfo.ts";
import {compute, Signal, signal} from "../../fjsc/src/signals.ts";
import {bagels} from "../constants/bagels.ts";

export class Menu {
    static page() {
        return Generics.pageFrame(
            true,
            verticalPage(
                create("h1")
                    .classes("flex-v")
                    .text("Menu")
                    .build(),
                create("h2")
                    .classes("flex-v")
                    .text("Choose your bagel")
                    .build(),
                Menu.bagelSelector(bagels)
            )
        )
    }

    static bagelSelector(types: BagelInfo[]) {
        const selectedBagel = signal<string|null>(types[0]?.name ?? null);

        return create("div")
            .classes("flex")
            .children(
                ...types.map(b => Menu.bagel(b, selectedBagel))
            ).build();
    }

    static bagel(bagel: BagelInfo, selectedBagel: Signal<string|null>) {
        const isSelected = compute(s => s === bagel.name, selectedBagel);
        const selectedClass = compute((s): string => s ? "selected" : "_", isSelected);

        return create("div")
            .classes("selectable-bagel", "flex-v", selectedClass)
            .onclick(() => selectedBagel.value = bagel.name)
            .children(
                create("img")
                    .src(bagel.image)
                    .build(),
                create("span")
                    .classes("bagel-name")
                    .text(bagel.name)
                    .build()
            ).build();
    }
}